// Lib
import React from 'react';

// Styles
import './EmptyBoardLoginToDesktopSuggestion.scss';

const EmptyBoardLoginToDesktopSuggestion = () => (
    <div className="EmptyBoardLoginToDesktopSuggestion">
        <div className="board-image">
            <img src={require('./hybrid-login-to-desktop-suggestion.png')} alt="" />
        </div>

        <p className="caption">Log in to milanote.com on your computer to organize your notes into visual boards</p>
    </div>
);

export default EmptyBoardLoginToDesktopSuggestion;
